// import { ReactComponent as LogoDark } from "../assets/images/logos/pedaylogo.svg";
// import { Link } from "react-router-dom";

// const Logo = () => {
//   return (
//     <Link to="/">
//       <LogoDark />
//     </Link>
//   );
// };

// export default Logo;

import DefaultLogo from "../assets/images/logos/pedaylogo.svg";
import { Link } from "react-router-dom";

const Logo = () => {
  const companyCode = localStorage.getItem("companyCode");
  const isAdmin = localStorage.getItem("isAdmin");

  let logoPath = DefaultLogo;

  // 👇 Only if NOT admin and companyCode exists
  if (isAdmin === "0" && companyCode) {
    try {
      logoPath = require(`../assets/images/logos/COM_${companyCode}.png`);
    } catch (error) {
      logoPath = DefaultLogo; // fallback to svg
    }
  }

  return (
   <Link to="/">
  <div style={{ display: "flex", alignItems: "center" }}>
    <img
      src={logoPath}
      alt="Company Logo"
      style={{
        height: "55px",   // 👈 yaha increase karo
        width: "auto"
      }}
    />
  </div>
</Link>
  );
};

export default Logo;
